module.exports = __webpack_public_path__ + "static/media/family-right.14374271.svg";